<template>
  <div class="publicItems">
    <div class="selectionArea search_box">
      <el-autocomplete
        v-model="accountList.value"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入主公众号"
        :clearable="true"
        @clear="(accountList.value = null),(accountList.address = null),(parameter.master_app_id = null)"
        @select="item=>{accountList = item, parameter.master_app_id = item.address }"
      />
      <el-select
        v-model="parameter.master_platform_id"

        placeholder="请选择平台"
        filterable
        :clearable="true"
        @clear="parameter.master_platform_id = null"
      >
        <el-option
          v-for="(item, index) in platformSelectList"
          :key="index"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-autocomplete
        v-model="novelItem.value"
        :fetch-suggestions="searchNovel"
        placeholder="请输入书籍名称"
        :clearable="true"
        @clear="(novelItem.value = null),(novelItem.address = null),(parameter.novel_id = null)"
        @select="item=>{novelItem = item, parameter.novel_id = item.address }"
      />
      <el-select
        v-model="parameter.launch_channel"

        placeholder="请选择投放渠道"
        :clearable="true"
        @clear="parameter.launch_channel = null"
      >
        <el-option
          v-for="(item, index) in channelSelectList"
          :key="index"
          :label="item.channel"
          :value="item.id"
        />
      </el-select>

      <el-autocomplete
        v-model="launchItem.value"
        :fetch-suggestions="searchLaunch"
        placeholder="请输入投手名称"
        :clearable="true"
        @clear="(launchItem.value = null),(launchItem.address = null),(parameter.launch_id = null)"
        @select="item=>{launchItem = item, parameter.launch_id = item.address }"
      />

      <el-date-picker
        v-model="parameter.out_no_date"
        type="date"
        placeholder="请选择出号日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
      />

      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />

      <el-button style="margin:0" type="primary" icon="el-icon-search" @click="getDataList()">搜索</el-button>
      <el-button style="margin:0" type="info" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="margin:0;" type="warning" icon="el-icon-download" @click="exportList">导出</el-button>
      <el-upload
        ref="upload"
        action
        :http-request="onUploadChange"
        :show-file-list="false"
      >
        <el-button style="margin:0" type="success" icon="el-icon-paperclip">导入成本</el-button>
      </el-upload>

    </div>
    <div class="content1">
      <div>
        合计
      </div>
      <div>
        <div>总充值：</div>
        <div>{{ tableData.total_amount }}</div>
      </div>
      <div>
        <div>总成本：</div>
        <div>{{ tableData.total_cost }}</div>
      </div>
      <div>
        <div>总回收率：</div>
        <div>{{ tableData.total_roi }}%</div>
      </div>
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="trade_date_str"
          align="center"
          label="日期"
        />
        <el-table-column
          prop="group_str"
          align="center"
          label="运营组"
        />
        <el-table-column
          prop="admin_str"
          align="center"
          label="运营者"
        />
        <el-table-column
          prop="account_names"
          label="公众号名称"
          align="center"
          min-width="150"
        >
          <template scope="scope">
            <ExpandClose
              :my-values="scope.row.account_names"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="master_platform_str"
          align="center"
          label="平台"
        />
        <el-table-column
          prop="novel_title"
          align="center"
          label="小说"
        />
        <el-table-column
          prop="launch_channel_str"
          align="center"
          label="投放渠道"
        />
        <!-- <el-table-column
          prop="launch_group_id_str"
          align="center"
          label="投手组"
        /> -->
        <el-table-column
          prop="launch_id_str"
          align="center"
          label="投手"
        />
        <el-table-column
          prop="out_no_date_str"
          align="center"
          label="出号日期"
        />
        <el-table-column
          prop="stat_cost"
          label="成本"
          align="center"
        >
          <template scope="scope">
            <div>
              <span v-if="!(activeItem && activeItem.id === scope.row.id)">{{ scope.row.cost }}</span>
              <input v-else v-model="activeText" type="number" autofocus style="width: 87px;padding: 5px;border: 1px solid #ccc;" @blur="blur1">
              <i v-if="!(activeItem && activeItem.id === scope.row.id)" class="el-icon-edit" style=" margin-left: 13px; font-size: 19px; cursor: pointer;" @click="(activeItem = scope.row),(activeText = scope.row.cost)" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="total_amount"
          label="总充值"
          align="center"
        />
        <el-table-column
          prop="total_amount_roi"
          label="总回收率"
          align="center"
        >
          <template scope="scope">
            <div>{{ scope.row.total_amount_roi }}%</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="new_user_amount"
          align="center"
          label="新用户充值"
        />
        <el-table-column
          prop="new_user_roi"
          align="center"
          label="新用户roi"
        >
          <template scope="scope">
            <div>{{ scope.row.new_user_roi }}%</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          align="center"
          label="今日充值"
        />
        <el-table-column
          prop="user_roi"
          align="center"
          label="今日回收率"
        >
          <template scope="scope">
            <div>{{ scope.row.user_roi }}%</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="increase"
          align="center"
          label="对比增长"
        >
          <template scope="scope">
            <div class="icon_box">
              <div>{{ scope.row.increase }}%</div>
              <i v-if="scope.row.increase && scope.row.increase < 0" class="el-icon-bottom icon" style="color: #0fe70f" />
              <i v-if="scope.row.increase && scope.row.increase > 0" class="el-icon-top icon" style="color: red" />
            </div>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { getReportList, updateCost, getPlatform, getOfficialAccount, reportCost, getChannelList, exportList, getIndexLauncher, getNovelList } from '@/api/platformLabel.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
export default {
  components: {
    PaginationRight,
    ExpandClose
  },
  data() {
    return {
      tableData: {},
      loading: false,
      // 分页信息
      parameter: {
        page: 1,
        page_size: 10,
        master_platform_id: null,
        master_app_id: null,
        launch_channel: null,
        out_no_date: null,
        novel_id: null,
        launch_id: null
      },
      activeItem: null,
      activeText: null,
      date: [],
      accountList: {}, // 主公众号筛选
      novelItem: {}, // 书籍筛选
      launchItem: {}, // 投手筛选
      platformSelectList: [], // 平台列表
      channelSelectList: [] // 投放渠道列表
    }
  },
  created() {
    // this.getDataList()
    this.myGetchannelplatform()
    this.getChannelList()
  },

  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await getReportList(
        {
          ...this.parameter,
          s_date: this.date[0],
          e_date: this.date[1]
        }
      )
      this.tableData = data.data
      this.tableData.list = data.data.list.map(item => {
        item.increase = Number(item.increase)
        return item
      })
      this.loading = false
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        master_platform_id: null,
        master_app_id: null,
        launch_channel: null,
        out_no_date: null
      }
      this.date = []
      this.accountList = {}
      this.novelItem = {}
      this.launchItem = {}
      // this.getDataList()
    },
    // 报表数据导出
    async exportList() {
      await exportList(
        {
          platform_id: this.parameter.master_platform_id,
          master_app_id: this.parameter.master_app_id,
          s_date: this.date[0],
          e_date: this.date[1]
        }
      )
      this.$message({
        message: '导出成功',
        type: 'success'
      })
    },
    // 请求平台
    async myGetchannelplatform() {
      const data = await getPlatform()
      this.platformSelectList = data.data.list
    },
    // 投放渠道列表
    async getChannelList() {
      const data = await getChannelList()
      this.channelSelectList = data.data
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 主公众号筛选
    async querySearchAsync(queryString, cb) {
      const data = await getOfficialAccount({ accountName: queryString || null })
      const news = (data.data.list.map((item) => {
        return {
          value: item.account_name,
          address: item.app_id
        }
      }))
      cb(news)
    },
    // 书籍筛选
    async searchNovel(queryString, cb) {
      if (!this.parameter.master_platform_id) {
        this.$message({
          message: '请先选择平台，才能选择书籍',
          type: 'warning'
        })
        return
      }
      const data = await getNovelList({
        novel_title: queryString || null,
        platform_id: this.parameter.master_platform_id
      })
      const news = (data.data.list.map((item) => {
        return {
          value: item.book_title,
          address: item.id
        }
      }))
      cb(news)
    },
    // 投手筛选
    async searchLaunch(queryString, cb) {
      const data = await getIndexLauncher({
        page: 1,
        page_size: 10,
        keywords: queryString || null
      })
      const news = (data.data.list.map((item) => {
        return {
          value: item.name,
          address: item.id + ''
        }
      }))
      cb(news)
    },
    // 修改成本
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await updateCost({ report_id: this.activeItem.id, cost: this.activeText })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },

    // 导出成本
    async onUploadChange(item) {
      const FormDatas = new FormData()
      FormDatas.append('cost_file', item.file)
      await reportCost(FormDatas)
      this.$message({
        message: '导出成功',
        type: 'success'
      })
    }
  }
}
</script>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}
.publicItems{
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;

}

.publicItems .selectionArea{
    margin-bottom: 20px;
}
.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
.icon_box{
  display:flex;
  justify-content: center;
}
.icon{
    font-weight: bold;
    font-size: 130%;
}

</style>

<style>
.publicItems .el-dialog{
  margin-top: 6vh !important;
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 7rem;
}
.content1>div>div:nth-child(2){
  color: rgb(194, 12, 12);
}
@media (max-width: 768px){
  .el-autocomplete{
    width:100%;
  }
  .content1{
    font-size:3vw;
  }
}
</style>
